import React, { useEffect }  from "react";
import { useParams, useLocation } from 'react-router-dom';
import ClientTab from "./components/ClientTab";
import Card from "components/card";
import SectionHeader from "components/section/SectionHeader";
import { connect } from "react-redux";
import { getClientDetails } from "../../../redux/client/clientState";


const ViewClient = ({getRecord, recordData }) => { 
	const { clientId } = useParams();
    const location = useLocation();

	let startTab = "details"; 
	if (location.pathname.includes("/client-teams")) startTab = "teams";
	else if (location.pathname.includes("/settings")) startTab = "settings";

	useEffect(() => {
		getRecord(clientId);
	}, [clientId, getRecord]);

	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<Card extra={"w-full h-full p-4"}>
					<div className="content-wrapper p-5 mb-2 rounded-lg shadow-md">
						<SectionHeader title={recordData?.clt_name || "Client"} />
					</div>
	      			<ClientTab recordId={clientId} startTab={startTab} />
				</Card>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.client.clientDetails?.data,
	requesting: state.client.clientDetails?.requesting,
	success: state.client.clientDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getClientDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewClient);